import type { IconProps } from '@/shared/ui/icons/types';

export const FlagGbIcon = (props: IconProps) => (
  <svg viewBox="0 0 28 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="28" height="20" fill="#012169" />
    <path d="M0 0 28 20M28 0 0 20" stroke="#fff" strokeWidth="4" />
    <path
      d="M0 0 28 20M28 0 0 20"
      stroke="#c8102e"
      strokeWidth="2.4"
      clipPath="url(#gb-clip)"
    />
    <clipPath id="gb-clip">
      <path d="M14 10 28 10 28 20zM14 10 14 20 0 20zM14 10 0 10 0 0zM14 10 14 0 28 0z" />
    </clipPath>
    <path d="M14 0V20M0 10H28" stroke="#fff" strokeWidth="6.667" />
    <path d="M14 0V20M0 10H28" stroke="#c8102e" strokeWidth="4" />
  </svg>
);
